export default __webpack_public_path__ + "static/media/Inter-ThinItalic.823c319a.woff";